
namespace Config {
  export const APP_MODE = import.meta.env.VITE_APP_MODE
  export const APP_NAME = import.meta.env.VITE_APP_NAME
  export const APP_ENV = import.meta.env.VITE_APP_ENV
  export const APP_HOST = import.meta.env.VITE_APP_HOST
  export const APP_URL = import.meta.env.VITE_APP_URL
  export const APP_DEBUG = import.meta.env.VITE_APP_DEBUG.toLowerCase() === 'true'
  export const API_URL = APP_URL + '/api'
  export const LOGIN_URL = import.meta.env.VITE_LOGIN_URL
  export const LOGOUT_URL = APP_URL + '/app/logout'
  export const DESTROY_URL = APP_URL + '/app/destroy'
  export const THUMB_BASE_URL = APP_URL + '/thumbs'
  export const FILE_BASE_URL = APP_URL + '/files'
}

export default Config
